import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { IonIcon, IonText } from '@ionic/angular/standalone';

@Component({
  selector: 'cmn-validation-errors',
  templateUrl: './validation-errors.component.html',
  styleUrls: ['./validation-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [IonText, IonIcon],
})
export class ValidationErrorsComponent {
  public readonly formControlRef = input.required<AbstractControl | null>();
  public readonly validationErrors =
    input<{ type: string; message: string }[]>();
}
